import { useState, useEffect } from 'react';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState<BeforeInstallPromptEvent | null>(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferred(e as BeforeInstallPromptEvent);
      // 延迟 3 秒显示，不打扰用户操作
      setTimeout(() => setShow(true), 3000);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  // 已安装（或隐藏后不再显示）
  if (!show || !deferred) return null;

  const install = async () => {
    await deferred.prompt();
    const { outcome } = await deferred.userChoice;
    console.log('[PWA] Install:', outcome);
    setShow(false);
    setDeferred(null);
  };

  const dismiss = () => setShow(false);

  return (
    <div className="fixed bottom-16 left-3 right-3 md:left-auto md:right-4 md:w-80 z-50 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-2xl shadow-2xl p-4 animate-slide-up">
      <div className="flex items-start gap-3">
        {/* 图标 */}
        <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-content-center flex-shrink-0 flex items-center justify-center">
          <span className="text-xl font-bold">ER</span>
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm">安装财务ERP到主屏幕</p>
          <p className="text-xs text-blue-100 mt-0.5">像APP一样使用，支持离线访问</p>
        </div>
        <button onClick={dismiss} className="text-blue-200 hover:text-white text-lg leading-none" aria-label="关闭">
          ✕
        </button>
      </div>
      <div className="flex gap-2 mt-3">
        <button
          onClick={install}
          className="flex-1 bg-white text-blue-600 font-semibold text-sm py-2 rounded-xl hover:bg-blue-50 transition"
        >
          安装
        </button>
        <button
          onClick={dismiss}
          className="px-4 text-sm py-2 rounded-xl border border-white/30 hover:bg-white/10 transition"
        >
          暂不
        </button>
      </div>
      {/* iOS 提示（Safari 不支持 beforeinstallprompt） */}
      {!window.navigator.standalone && /iphone|ipad|ipod/i.test(navigator.userAgent) && (
        <p className="text-xs text-blue-200 mt-2 text-center">
          👆 Safari 浏览器点击「分享」→「添加到主屏幕」
        </p>
      )}
    </div>
  );
}
